export default __webpack_public_path__ + "static/media/852.76ff04fd.png";